var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"harvest-Plan-View"},[_c('PageTitle',{attrs:{"imagem":"Planejamento.png","main":"Plano de Moagem e Produção","sub":""}}),_c('HarvestPlanViewTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }